module.exports = __webpack_public_path__ + "img/noresult.3ced87ea.svg";